module.exports = __webpack_public_path__ + "static/img/14.81d4458.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/14.png
// module id = Ysc0
// module chunks = 0